module.exports = __webpack_public_path__ + "box1.c8f14b45.png";